import { render, staticRenderFns } from "./flight.vue?vue&type=template&id=4f9ac00c&scoped=true"
import script from "./flight.vue?vue&type=script&lang=js"
export * from "./flight.vue?vue&type=script&lang=js"
import style0 from "./flight.vue?vue&type=style&index=0&id=4f9ac00c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9ac00c",
  null
  
)

export default component.exports